import React, { Component } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import styled from 'styled-components';

import {
  InputGroup,
  IMessage,
  FBMessenger,
  FBMessengerUrl,
  InstagramDM,
  InstagramUrlDM,
  Whatsapp
} from '../../components/share';

import domains from '../../containers/Domains';

const Container = styled.div`
  overflow: hidden;
  max-width: 100%;
`;
const SliderContainer = styled.div`
  margin: 0 25px;
`;
const Title = styled.h1`
  margin-bottom: 20px;
  text-align: center;
  color: #111;
`;
const Center = styled.div`
  text-align: center;
`;
const InputContainer = styled.div`
  max-width: 480px;
  margin: 50px auto;
`;

class AdShareMetadataUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      item: {},
      loading: false
    };
  }

  onSubmit = async () => {
    try {
      this.setState({ loading: true, item: {} });
      const item = await axios(
        `${domains[window.location.hostname]}metadata?url=${this.state.url}`
      );
      this.setState({ loading: false, item: item.data });
    } catch (err) {
      this.setState({ loading: false });
      console.log(err);
    }
  };

  subStr = (text) => {
    return text.length > 100 ? `${text.substring(0, 100)}...` : text;
  };

  renderPreviews = () => {
    const { item } = this.state;
    const title = item['og:title'];
    const description = item.description;
    const image = item.image;

    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1098,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <SliderContainer>
        <Slider {...settings}>
          <IMessage
            image={image}
            source={item.source}
            description={title}
            link={item.url}
            subStr={this.subStr}
          />
          <FBMessenger
            image={image}
            source={item.source}
            link={item.url}
            noIcon
            subStr={this.subStr}
          />
          <FBMessengerUrl
            title={title}
            description={description}
            image={image}
            source={item.source}
            link={item.url}
            subStr={this.subStr}
          />
          <InstagramDM
            image={image}
            author=""
            authorImage=""
            description={title}
            link={item.url}
            subStr={this.subStr}
          />
          <InstagramUrlDM
            image={image}
            author=""
            authorImage=""
            description={title}
            link={item.url}
            subStr={this.subStr}
          />
          <Whatsapp
            image={image}
            shortDescription={description}
            description={title}
            metadata={``}
            link={item.url}
            source={item.source}
            subStr={this.subStr}
          />
        </Slider>
      </SliderContainer>
    );
  };

  render() {
    return (
      <Container className="container">
        <Title>Metada Url</Title>
        <Center>
          <InputContainer>
            <InputGroup
              placeholder="Enter your url"
              actionText="GO!"
              value={this.state.url}
              onChange={(ev) => this.setState({ url: ev.target.value })}
              onAction={this.onSubmit}
              loading={this.state.loading}
              action
            />
          </InputContainer>
          {Object.keys(this.state.item).length > 0 && this.renderPreviews()}
        </Center>
      </Container>
    );
  }
}

export default AdShareMetadataUrl;



// WEBPACK FOOTER //
// ./src/screens/AdShare/MetadataUrl.js